// VIN Lookup Class
import { loading } from 'commonAssets/js/constants';
import { loadingGif, modal } from 'commonAssets/js/helpers';

const showLoading = () => loadingGif(loading, 'show');
const hideLoading = () => loadingGif(loading, 'hide');
const showError = (message) => modal('Error', message);

export class VINLookup {
    constructor(claim, vin) {
        this.claim = claim;
        this.vin = vin;
        this.lookup = {
            domain: claim.data.domain,
            searchFields: {
                vin: vin,
            },
        };
    }

    async execute() {
        try {
            const result = await this.claim.api.classMemberSearchV2Post({}, this.lookup);
            if (result.data.error) {
                showError(`<p class="fw-bold">${result.data.error}</p>`);
                return;
            }

            if (Object.keys(result.data).length === 0) {
                showError('No data found for the provided VIN. Please check and try again.');
                return;
            }

            if (result.data.vin) {
                document.querySelector('#zero_zero_id').value = result.data.zero_zero_id || result.data.vin;
                document.querySelector('#confirmation_code').value = result.data.confirmation_code || result.data.vin;
                document.querySelector('#submit-guard').click();
            }

        } catch (error) {
            console.error(error);
            hideLoading();
            showError('An error occurred while checking the VIN. Please try again.');
        }
    }
}